import { IObjectTranslatable } from ".";
import { INotImplementedItemBean, ITypeDefinable } from "../beans/items";
import { IItem, NotImplementedItem } from "../../../../domain/document/items";

import {
  Point,
  Size,
  Rectangle,
} from "../../../../domain/drawing";

export class NotImplementedItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as INotImplementedItemBean;
    const result = new NotImplementedItem(bean.type, bean);
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.value = bean.value;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    // 何も返さないとオブジェクト自体が無かったことになってしまうので、とりあえず元のbeanを返却する
    const target = item as NotImplementedItem;
    return target.source !== undefined
      ? target.source
      : null;
  }
}
